// import React from 'react';

// const ContactUs = () => {
//   return (
//     <div className="contact-us container py-5">
//       <h2 className="text-center text-danger fw-bold mb-4">Contact Us</h2>

//       <div className="row">
//         {/* Google Map Section */}
//         <div className="col-lg-6 col-12 mb-4">
//           <div className="google-map">
//             {/* Embedding Google Map */}
//             <iframe
//               title="Google Map"
//               width="100%"
//               height="350"
//               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14889.290470453745!2d79.12103604580233!3d21.09970032610429!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4b94785095bcd%3A0x125bf78494815903!2sPRAKASH%20Institute%20of%20Education%20%2CNagpur!5e0!3m2!1sen!2sin!4v1738244576962!5m2!1sen!2sin"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//             ></iframe>
//           </div>
//         </div>

//         {/* Form Section */}
//         <div className="col-lg-6 col-12 mb-4 d-flex justify-content-center align-items-center">
//           <div className="card shadow" style={{ width: '100%', maxWidth: '500px', padding: '20px' }}>
//             <div className="card-body">
//               <h5 className="card-title text-center text-danger">Get in Touch</h5>
//               <form>
//                 <div className="mb-3">
//                   <label htmlFor="name" className="form-label">
//                     Your Name
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     id="name"
//                     placeholder="Enter your name"
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label htmlFor="email" className="form-label">
//                     Email address
//                   </label>
//                   <input
//                     type="email"
//                     className="form-control"
//                     id="email"
//                     placeholder="Enter your email"
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label htmlFor="phone" className="form-label">
//                     Phone Number
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     id="phone"
//                     placeholder="Enter your phone number"
//                   />
//                 </div>
//                 <button type="submit" className="btn btn-danger w-100">
//                   Submit
//                 </button>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContactUs;




import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

const ContactUs = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      e.target,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    )
    .then(
      (result) => {
        console.log('Email sent:', result.text);
        alert('Message sent successfully!');
      },
      (error) => {
        console.log('Error:', error.text);
        alert('Failed to send message. Try again.');
      }
    );
  };

  return (
    <div className="contact-us container py-5 mt-5">
      <h2 className="text-center text-danger fw-bold mb-4">Contact Us</h2>

      <div className="row">
        {/* Google Map Section */}
        <div className="col-lg-6 col-12 mb-4">
          <div className="google-map">
            <iframe
              title="Google Map"
              width="100%"
              height="350"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14889.290470453745!2d79.12103604580233!3d21.09970032610429!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4b94785095bcd%3A0x125bf78494815903!2sPRAKASH%20Institute%20of%20Education%20%2CNagpur!5e0!3m2!1sen!2sin!4v1738244576962!5m2!1sen!2sin"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>

        {/* Form Section */}
        <div className="col-lg-6 col-12 mb-4 d-flex justify-content-center align-items-center">
          <div className="card shadow" style={{ width: '100%', maxWidth: '500px', padding: '20px' }}>
            <div className="card-body">
              <h5 className="card-title text-center text-danger">Get in Touch</h5>
              <form ref={form} onSubmit={sendEmail}>
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">Your Name</label>
                  <input type="text" className="form-control" name="user_name" placeholder="Enter your name" required />
                </div>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email address</label>
                  <input type="email" className="form-control" name="user_email" placeholder="Enter your email" required />
                </div>
                <div className="mb-3">
                  <label htmlFor="phone" className="form-label">Phone Number</label>
                  <input type="text" className="form-control" name="user_phone" placeholder="Enter your phone number" required />
                </div>
                <button type="submit" className="btn btn-danger w-100">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;